import React from 'react';
import SEOManagement from './SEOManagement';

const Sitemap = () => {
  return <SEOManagement tab="sitemap" />;
};

export default Sitemap;
